import React from 'react';
import Layout from '../../components/Layout';
import ProductsList from '../../components/Products';

class CatalogPage extends React.Component {

  componentDidMount() {
    document.title = 'Mo!'; // title;
  }

  render() {
    return (
      <Layout>
        <ProductsList />
      </Layout>
    );
  }

}

export default CatalogPage;



/** WEBPACK FOOTER **
 ** ./pages/catalog/index.js
 **/